import SevereNeuytropenia from "@components/severe-neutropenia";
import * as React from 'react';
export default {
  SevereNeuytropenia,
  React
};